export function getFareEstimates(data) {
  return {
    types: [
      `FARE_ESTIMATES_PENDING`,
      `FARE_ESTIMATES_FULFILLED`,
      `FARE_ESTIMATES_REJECTED`,
    ],
    method: "POST",
    url: "trip/v1/auth/cabs/fare-estimates",
    data,
    service: "trnzOpenApi",
  };
}

export function getSelectedCab(data) {
  return {
    types: [
      `SELECTED_CAB_PENDING`,
      `SELECTED_CAB_FULFILLED`,
      `SELECTED_CAB_REJECTED`,
    ],
    method: "POST",
    url: "trip/v1/auth/cabs/block",
    data,
    service: "trnzOpenApi",
  };
}

export function confirmSelectedCab(data) {
  return {
    types: [
      `CONFIRM_SELECTED_CAB_PENDING`,
      `CONFIRM_SELECTED_CAB_FULFILLED`,
      `CONFIRM_SELECTED_CAB_REJECTED`,
    ],
    method: "POST",
    url: "trip/v1/auth/bookings/confirm",
    data,
    service: "trnzOpenApi",
  };
}

export function getNewEnqDetail(id) {
  return {
    types: [
      `GET_NEW_ENQUIRY_DETAIL_PENDING`,
      `GET_NEW_ENQUIRY_DETAIL_FULFILLED`,
      `GET_NEW_ENQUIRY_DETAIL_REJECTED`,
    ],
    method: "GET",
    url: `trip/v1/auth/admin/enquiries/${id}`,
    service: "trnzOpenApi",
  };
}


export function updateVehicleFare(enquiryId, inventoryId, newTotalFare) {
  return {
    types: [
      `UPDATE_VEHICLE_FARE_PENDING`,
      `UPDATE_VEHICLE_FARE_FULFILLED`,
      `UPDATE_VEHICLE_FARE_REJECTED`,
    ],
    method: "PATCH",
    url: `trip/v1/auth/admin/enquiries/${enquiryId}/inventory/${inventoryId}/fare`,
    data: { newTotalFare: Number(newTotalFare) },
    service: "trnzOpenApi",
  };
}